import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function SideMenu({ open, onClose, onSelectCategory, activeCategory }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (open) {
      api.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
    }
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            data-testid="menu-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/40 z-[110] backdrop-blur-sm"
          />
          <motion.aside
            data-testid="side-menu"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", ease: [0.22, 1, 0.36, 1], duration: 0.5 }}
            className="fixed top-0 right-0 bottom-0 w-full sm:w-[420px] bg-[#FDFBF7] z-[120] overflow-y-auto"
          >
            <div className="flex items-center justify-between px-8 py-6 border-b border-black/10">
              <span className="overline text-[#76746F]">Navigation</span>
              <button
                data-testid="close-menu-button"
                onClick={onClose}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-black/15 hover:border-black hover:bg-black hover:text-white transition-colors"
                aria-label="Close menu"
              >
                <X size={18} strokeWidth={1.5} />
              </button>
            </div>

            <div className="px-8 py-10 space-y-12">
              <div>
                <p className="overline text-[#76746F] mb-4">Categories</p>
                <ul className="space-y-3">
                  <li>
                    <button
                      data-testid="filter-all"
                      onClick={() => { onSelectCategory(null); onClose(); }}
                      className={`font-serif-display text-3xl tracking-tight transition-colors ${!activeCategory ? "text-[#1A1A1A]" : "text-[#76746F] hover:text-[#1A1A1A]"}`}
                    >
                      All Stories
                    </button>
                  </li>
                  {categories.map((c) => (
                    <li key={c.id}>
                      <button
                        data-testid={`filter-${c.slug}`}
                        onClick={() => { onSelectCategory(c.name); onClose(); }}
                        className={`font-serif-display text-3xl tracking-tight transition-colors ${activeCategory === c.name ? "text-[#1A1A1A]" : "text-[#76746F] hover:text-[#1A1A1A]"}`}
                      >
                        {c.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="border-t border-black/10 pt-8">
                <p className="overline text-[#76746F] mb-4">More</p>
                <ul className="space-y-3 font-sans-modern">
                  <li>
                    <Link
                      to="/about"
                      data-testid="menu-about"
                      onClick={onClose}
                      className="text-base text-[#1A1A1A] hover:underline underline-offset-4"
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/advertise"
                      data-testid="menu-advertise"
                      onClick={onClose}
                      className="text-base text-[#1A1A1A] hover:underline underline-offset-4"
                    >
                      Advertise with Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      data-testid="menu-contact"
                      onClick={onClose}
                      className="text-base text-[#1A1A1A] hover:underline underline-offset-4"
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/admin/login"
                      data-testid="menu-admin"
                      onClick={onClose}
                      className="text-sm text-[#76746F] hover:text-[#1A1A1A] hover:underline underline-offset-4"
                    >
                      Admin
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="px-8 py-8 border-t border-black/10 text-xs text-[#76746F]">
              © {new Date().getFullYear()} Queens Daily — Stories for women, by women.
            </div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}
